



















































































import {
  defineComponent,
  onMounted,
  reactive,
  ref,
} from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';
import { debounce } from 'lodash';

import {
  getSupplier,
  createSupplier,
  updateSupplier,
  checkExistingSupplierCode,
} from '@/api/index';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import StickyFooterActionBar from '@/components/StickyFooterActionBar.vue';
import GroupAddressEditor from '@/components/LocationAddress/GroupAddressEditor.vue';

const PageColumnWithSupplierEditor = defineComponent({
  components: {
    StickyFooterActionBar,
    CommonModalWithPreset,
    GroupAddressEditor,
  },
  props: {
    edit: { default: false },
  },
  setup(props) {
    const { route } = useRouter();
    const confirmModal = ref(null);
    const form = reactive({
      id: -1,
      name: '',
      branch: '',
      code: '',
      taxId: '',
      phone: '',
      email: '',
      credit_days: '',
      showAsEnglish: false,
      address: {
        address: '',
        province: {},
        district: {},
        subdistrict: {},
        zipcode: '',
      },
      call: async () => {
        if (props.edit) {
          const result = await updateSupplier(form.id, {
            name: form.name,
            address: form.address.address,
            code: form.code,
            branch: form.branch,
            phone: form.phone,
            email: form.email,
            taxId: form.taxId,
            credit_days: parseInt(form.credit_days, 10),
            showAsEnglish: form.showAsEnglish,
            districtId: (form.address.district as any)?.id || null,
            provinceId: (form.address.province as any)?.id || null,
            subdistrictId: (form.address.subdistrict as any)?.id || null,
            zipcode: form.address.zipcode,
          });
        } else {
          const result = await createSupplier({
            name: form.name,
            address: form.address.address,
            code: form.code,
            branch: form.branch,
            phone: form.phone,
            email: form.email,
            taxId: form.taxId,
            credit_days: parseInt(form.credit_days, 10),
            showAsEnglish: form.showAsEnglish,
            districtId: (form.address.district as any)?.id || null,
            provinceId: (form.address.province as any)?.id || null,
            subdistrictId: (form.address.subdistrict as any)?.id || null,
            zipcode: form.address.zipcode,
          });
        }
        (confirmModal.value as any).compose({ body: '', action: 'บันทึก', entity: 'ข้อมูลเรียบร้อย' });
      },
      state: {
        value: 'READY',
      },
    });
    function clear() {
      form.name = '';
      form.branch = '';
      form.code = '';
      form.taxId = '';
      form.phone = '';
      form.email = '';
      form.credit_days = '';
      form.showAsEnglish = false;
      form.address = {
        address: '',
        province: {},
        district: {},
        subdistrict: {},
        zipcode: '',
      };
    }
    onMounted(async () => {
      if (props.edit) {
        const result = (await getSupplier(route.value.params.id)).data;
        form.id = result.id;
        form.name = result.name;
        form.code = result.code;
        form.branch = result.branch;
        form.phone = result.phone;
        form.email = result.email;
        form.taxId = result.taxId;
        form.credit_days = result.credit_days;
        form.showAsEnglish = result.show_as_english;
        form.address.address = result.address;
        form.address.province = result.province;
        form.address.district = result.district;
        form.address.subdistrict = result.sub_district;
        form.address.zipcode = result.zipcode;
      }
    });

    // Check existing Code
    const failedValidatedCodeRule = ref({ excluded: '', required: true });
    const pendingCheckExistingSupplierCode = debounce(async () => {
      const result = form.code ? await checkExistingSupplierCode(form.code) : { exist: false, latest: '' };

      if (result.exist && !props.edit) failedValidatedCodeRule.value.excluded = form.code;
      else failedValidatedCodeRule.value.excluded = '';
    }, 250);

    return {
      form,
      confirmModal,
      clear,

      failedValidatedCodeRule,
      pendingCheckExistingSupplierCode,
    };
  },
});

export default PageColumnWithSupplierEditor;
